/* eslint-disable */
export default {
  dialPlaceholder: 'Escribir nombre o número',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
